export default "__VITE_ASSET__ca78761f__"